import { PlanRecordKeyTypes } from '@constants/plans'
import { useGetPlanLimits } from '@pages/Checkout/hooks/useGetPlanLimits'
import { Spacer } from '@ui-kit'
import { Dispatch, FC, SetStateAction } from 'react'
import { Column } from 'simple-flexbox'

import styles from './Limits.module.scss'

interface LimitsProps {
  recordKey: PlanRecordKeyTypes
  setPlanTypeName?: Dispatch<SetStateAction<PlanRecordKeyTypes>>
}

export const Limits: FC<LimitsProps> = ({ recordKey, setPlanTypeName }) => {
  const { visits, domains, landingPages } = useGetPlanLimits({
    recordKey,
    setPlanTypeName
  })

  return (
    <Column>
      <Column className={styles.limits__visits} vertical='center'>
        {visits}
      </Column>

      <Spacer space={5} />

      {domains}

      <Spacer space={5} />

      {landingPages}
    </Column>
  )
}

Limits.displayName = 'CheckoutPlansPlanPanelsPlanLimits'
